import React from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const HomeDeliveryWorks = () => {
  const { t } = useTranslation();

  return (
    <div className="homeDeliveryWorks">
      <h2>{t('How home delivery works')}</h2>
      <div className="homeDeliveryWorksContainer">
        <div className="steps step-1">
          <span>
            <LazyLoadImage
              src="/content/images/homeDelivery/step1.png"
              alt=""
            />
          </span>
          <div className="text-containt-wrapper">
            <p className="number">1</p>
            <div className="text">
              <h3 className="steps-title">
                {t('Look for the home delivery')}&nbsp;
                <br className="desktop-only" />
                {t('button whenever you')} <br className="desktop-only" />
                {t('search for prescriptions on')}&nbsp;
                <br className="desktop-only" />
                {t('SingleCare')}.
              </h3>
            </div>
          </div>
        </div>
        <div className="leftImageContainer">
          <LazyLoadImage
            src="/content/images/homeDelivery/path-top.png"
            alt=""
            className="mobile-only"
          />
          <LazyLoadImage
            src="/content/images/homeDelivery/path-desktop-left.png"
            alt=""
            className="desktop-only"
          />
        </div>
        <div className="steps step-2">
          <span>
            <LazyLoadImage
              src="/content/images/homeDelivery/step2.svg"
              alt=""
            />
          </span>
          <div className="text-containt-wrapper">
            <p className="number">2</p>
            <div className="text">
              <h3 className="steps-title">
                {t('Provide some basic')} <br className="desktop-only" />
                {t('information to our')} <br className="desktop-only" />
                {t('trusted delivery partner')}&nbsp;
                <br className="desktop-only" />
                {t('GeniusRx')}.
              </h3>
            </div>
          </div>
        </div>
        <div className="rightImageContainer">
          <LazyLoadImage
            src="/content/images/homeDelivery/path-desktop-right.png"
            alt=""
            className="desktop-only"
          />
          <LazyLoadImage
            src="/content/images/homeDelivery/path-bottom.png"
            alt=""
            className="mobile-only"
          />
        </div>
        <div className="steps step-3">
          <span>
            <LazyLoadImage
              src="/content/images/homeDelivery/step3.png"
              alt=""
              width="98px"
            />
          </span>
          <div className="text-containt-wrapper">
            <p className="number">3</p>
            <div className="text">
              <h3 className="steps-title">
                {t('Get your prescriptions')} <br className="desktop-only" />
                {t('delivered with free')} <br className="desktop-only" />
                {t('shipping included to all')} <br className="desktop-only" />
                {t('50 states')}.
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomeDeliveryWorks;
